import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IDamageReportReducer } from '../../../reducers/damageReportReducer';
import { RootState } from '../../../store';
import Button from '../../base/button';
import { A, H4 } from '../../base/typography';
import { P } from '../../base/typography/typography';
import { RawLoader } from '../../loading/loading';
import { WizardPageProps } from '../../wizard/wizard';
import * as StyledFormResponseMessage from './formResponseMessage.styles';
import { getEmailSentTo } from './helper';

interface Props extends WizardPageProps {
	success: boolean;
	loading: boolean;
}

const FormResponseMessage: FC<Props> = ({ success, loading }) => {
	const { t } = useTranslation('damageReport');
	const title = success ? t('form-response.thank-you') : t('form-response.error');

	const damageReportReducer: IDamageReportReducer = useSelector((store: RootState) => store.damageReportReducer);

	const emailSentTo = getEmailSentTo(damageReportReducer);

	return (
		<StyledFormResponseMessage.Wrapper>
			{!loading && <H4 marginBottom="2rem">{title}</H4>}
			{!loading && success && <P>{`${t('form-response.text-success')} ${emailSentTo}`}</P>}
			{!loading && !success && <P>{t('form-response.text-error')}</P>}
			{loading && <RawLoader />}
			<A href={t('form-response.back-button-path')}>
				<Button primary>{t('form-response.back-button')}</Button>
			</A>
		</StyledFormResponseMessage.Wrapper>
	);
};

export default FormResponseMessage;
